import { useCallback, useMemo } from 'react';
import dayjs from 'dayjs';

export function useIsDayExcluded(availableDates: Date[] | undefined) {
  const dates = useMemo(
    () =>
      availableDates?.map((date) => dayjs(date).format('YYYY-MM-DD')) ?? null,
    [availableDates]
  );
  return useCallback(
    (date: string | Date) => {
      if (!dates) {
        return false;
      }

      const dateKey =
        typeof date === 'string' ? date : dayjs(date).format('YYYY-MM-DD');
      return !dates.includes(dateKey);
    },
    [dates]
  );
}
